"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _Modal = _interopRequireDefault(require("../../../Modal"));
var _actions = require("./store/actions");
var _OfferDetails = _interopRequireDefault(require("./OfferDetails"));
var _styles = _interopRequireDefault(require("./styles"));
var _constants = require("./constants");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var OfferDetailsModal = function OfferDetailsModal(_ref) {
  var hotelID = _ref.hotelID,
    offerID = _ref.offerID,
    queryID = _ref.queryID,
    _onClose = _ref.onClose,
    onClickByPrice = _ref.onClickByPrice,
    onOpenMap = _ref.onOpenMap;
  var dispatch = (0, _reactRedux.useDispatch)();
  (0, _react.useEffect)(function () {
    return function () {
      dispatch((0, _actions.resetStore)());
    };
  }, [dispatch]);
  return /*#__PURE__*/_react.default.createElement(_Modal.default, {
    closeIcon: true,
    className: _styles.default.modal,
    rootID: _constants.OFFER_DETAILS_MODAL_ID,
    onClose: function onClose() {
      return _onClose();
    }
  }, /*#__PURE__*/_react.default.createElement(_Modal.default.Content, {
    className: _styles.default.modalContent
  }, /*#__PURE__*/_react.default.createElement(_OfferDetails.default, {
    isModalMode: true,
    hotelID: hotelID,
    offerID: offerID,
    queryID: queryID,
    onClickByChartBar: onClickByPrice,
    onOpenMap: onOpenMap
  })));
};
OfferDetailsModal.propTypes = {
  hotelID: _propTypes.default.number.isRequired,
  offerID: _propTypes.default.string.isRequired,
  queryID: _propTypes.default.string.isRequired,
  onOpenMap: _propTypes.default.func
};
var _default = exports.default = OfferDetailsModal;